



















import { Component, Vue, Inject } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import MeetCalendar from "@/components/meet-calendar.vue";
import Schedule from "./appointment/schedule.vue";
import MyAppointment from "./appointment/myappointment.vue"

@Component({ components: { MeetCalendar, Schedule, MyAppointment } })
export default class Appointment extends AbpBase {
  scheduleModal: boolean = false;
  myAppointmentModal: boolean = false;
  offices: Array<any> = [];
  users: Array<any> = [];
  schemes: Array<any> = [];

  clickDay(item) {
    if(new Date(item.date) < new Date()) return;
    (this.$refs.schedule as any).init(item.title, this.offices, item.year, item.month, item.day, this.users, this.schemes);
    this.scheduleModal = true;
  }
  openMyAppointment(){
    (this.$refs.myappointment as any).init();
    this.myAppointmentModal = true;
  }
  refresh(){
    (this.$refs.meetCalendarForm as any).refresh();
  }
  async getOffices(){
    this.offices = await this.$store.dispatch({
      type: "office/getOffices"
    })
  }
  async getDefaultUsers(){
    this.users = await this.$store.dispatch({
      type: "user/getDefaultUsers"
    })
  }
  async getAllScheme(){
    this.schemes = await this.$store.dispatch({
      type:"scheme/getAllScheme"
    })
  }
  created(){
    this.getOffices();
    this.getDefaultUsers();
    this.getAllScheme();
  }
}
